import { useTheme, type ThemeChoice } from '../theme';

const OPTIONS: [ThemeChoice, string, string][] = [
  ['light', '☀️', 'Deschis'],
  ['dark', '🌙', 'Închis'],
  ['system', '🖥', 'Automat (ca sistemul)'],
];

/** Alegerea temei — se aplică imediat și se păstrează în acest browser. */
export function ThemePicker() {
  const [choice, setChoice] = useTheme();
  return (
    <section className="theme-section">
      <h2>Temă</h2>
      <div className="theme-choice">
        {OPTIONS.map(([v, icon, label]) => (
          <button key={v} className={choice === v ? 'on' : ''} onClick={() => setChoice(v)}>
            <span>{icon}</span> {label}
          </button>
        ))}
      </div>
      <p className="muted small">Se aplică imediat și se păstrează în acest browser. „Automat” urmează setarea de luminozitate a calculatorului sau telefonului.</p>
    </section>
  );
}

/** Comutator rapid în bara laterală (Deschis ↔ Închis). */
export function ThemeToggle() {
  const [, setChoice, effective] = useTheme();
  return (
    <button className="theme-toggle" title={effective === 'dark' ? 'Temă deschisă' : 'Temă închisă'}
      onClick={() => setChoice(effective === 'dark' ? 'light' : 'dark')}>
      {effective === 'dark' ? '☀️' : '🌙'}
    </button>
  );
}
